import React, {useState} from "react";
import {NavbarCollapse} from "../../../shared_lib/bootstrap/navBar/NavbarCollapse";
import logo from "./../../../assets/img/logo/logo.png";
import {NavUser} from "./NavUser";
import {SidebarRight} from "./SidebarRight";
import {useRoute} from "../../../utils/useRoute";
import userManager from "../../../utils/oidcUserManager";
import {useSelector} from "react-redux";
import {NavbarLanding} from "../../../shared_lib/bootstrap/navBar/NavbarLanding";

export const Navbar: React.FC = () => {
    const {changeRoute} = useRoute();
    const [toggleSidebar, setToggleSidebar] = useState(false);

    const logoutClick = () => {
        setToggleSidebar(false);
        userManager.signoutRedirect();
    };

    const {user} = useSelector((state: any) => state.auth);
    return (
        <>
            <NavbarLanding
                logo={
                    <img
                        className={"pointer logo-brand"}
                        src={logo}
                        alt=""
                        width={"130px"}
                    />
                }
                setToggleSidebar={setToggleSidebar}
                toggleSidebar={toggleSidebar}
                // navLeft={<div className={"heading-1"}>Linde Digital Suite</div>}
                /* navCenter={<NavCenter />}*/
                navRight={
                    <NavUser
                        user={user}
                        setToggleSidebarHandler={() => setToggleSidebar(!toggleSidebar)}
                    />
                }
                sidebarRight={<SidebarRight logoutClick={logoutClick} user={user}/>}
            />
        </>
    );
};
